import { Flex, Text } from '@chakra-ui/react';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface DateCellProps {
  dateString: string | null;
}

const formatDate = (dateString: string | null, locale: string | undefined): string => {
  if (!dateString) return '-';
  try {
    return new Date(dateString).toLocaleDateString(locale, {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  } catch {
    return 'Invalid Date';
  }
};

const formatTime = (dateString: string | null, locale: string | undefined): string => {
  if (!dateString) return '';
  try {
    return new Date(dateString).toLocaleTimeString(locale, {
      hour: '2-digit',
      minute: '2-digit',
    });
  } catch {
    return '';
  }
};

/** A table date and its time, spelled in the UI language rather than the browser's. */
const DateCell: React.FC<DateCellProps> = ({ dateString }) => {
  const { i18n } = useTranslation();
  const locale = i18n?.language;

  if (!dateString) {
    return <Text fontSize="sm">-</Text>;
  }

  return (
    <Flex direction="column">
      <Text fontSize="sm">{formatDate(dateString, locale)}</Text>
      <Text fontSize="xs" color="gray.500">
        {formatTime(dateString, locale)}
      </Text>
    </Flex>
  );
};

export default DateCell;
